import { createReducer } from 'deox';
import { uiActions } from '@/redux/actions/ui';
import { Device } from '@/types';
import { Paths } from '@/pages/routers';

export interface UIState {
  device: {
    type: string;
    width: number;
  };
  pagesInfo: {
    pathname: string;
    coordinates?: {
      x: number;
      y: number;
    };
    viewMode?: string;
  }[];
  openedSubscribePopup: boolean;
}

const initialState: UIState = {
  device: {
    type: window.innerWidth >= 769 ? Device.desktop : Device.mobile,
    width: window.innerWidth,
  },
  pagesInfo: [
    {
      pathname: Paths.Directory,
      coordinates: undefined,
      viewMode: undefined,
    },
    {
      pathname: Paths.Home,
      coordinates: undefined,
      viewMode: undefined,
    },
  ],
  openedSubscribePopup: false,
};

const uiReducer = createReducer(initialState, (handleAction) => [
  handleAction(uiActions.setDevice, (state, { payload }) => {
    return {
      ...state,
      device: {
        type: payload.deviceWidth >= 769 ? Device.desktop : Device.mobile,
        width: payload.deviceWidth,
      },
    };
  }),
  handleAction(uiActions.persistCoordinate, (state, { payload }) => {
    const { pathname, coordinate } = payload;
    const newPageCoordinate = state.pagesInfo.map((page) =>
      page.pathname === pathname
        ? {
            ...page,
            coordinates: {
              x: coordinate.x,
              y: coordinate.y,
            },
          }
        : page
    );
    return {
      ...state,
      pagesInfo: newPageCoordinate,
    };
  }),
  handleAction(uiActions.persistViewMode, (state, { payload }) => {
    const { pathname, viewMode } = payload;
    const newPageViewMode = state.pagesInfo.map((page) => (page.pathname === pathname ? { ...page, viewMode } : page));
    return {
      ...state,
      pagesInfo: newPageViewMode,
    };
  }),
  handleAction(uiActions.setOpenSubscribePopup, (state, { payload }) => {
    const { openedSubscribePopup } = payload;
    return {
      ...state,
      openedSubscribePopup,
    };
  }),
]);

export default uiReducer;
